import React from 'react'
import PropTypes from 'prop-types'
import { sendHoverSoundCommand, sendClickSoundCommand } from 'react-wot-bootstrap'

import { FILTERS_BUTTON } from '../../constants'

import styles from './FiltersButton.scss'

const FiltersButton = ({ onClick }) => {
    const handleClick = () => {
        sendClickSoundCommand()
        onClick()
    }

    return (
        <div className={styles.base} onClick={handleClick} onMouseEnter={sendHoverSoundCommand}>
            <span className={styles.icon} />
            {FILTERS_BUTTON}
        </div>
    )
}

FiltersButton.propTypes = {
    onClick: PropTypes.func,
}

export default FiltersButton



// WEBPACK FOOTER //
// ./containers/Landing/components/LandingClans/components/FiltersButton/FiltersButton.jsx